/* global BigInt */
import Cookies from "universal-cookie";
import {
  DOMAIN_COOKIE,
  MapCurrency,
  USD,
} from "../constants";
import moment from "moment";
import { isArray } from "lodash";
import { Web3 } from "web3";
import { baseCurrencyCode, decimalScaleByCurrency, decimalSeparatorByCurrency, thousandSeparatorByCurrency } from "./Currency";
const CryptoJS = require("crypto-js");

export function getPopupOffset({ width, height }) {
  const wLeft = window.screenLeft ? window.screenLeft : window.screenX;
  const wTop = window.screenTop ? window.screenTop : window.screenY;

  const left = wLeft + window.innerWidth / 2 - width / 2;
  const top = wTop + window.innerHeight / 2 - height / 2;
  return { top, left };
}

export function getPopupDimensions({ width, height }) {
  const { top, left } = getPopupOffset({ width, height });
  return `width=${width},height=${height},top=${top},left=${left}`;
}

export function getQueryVariable(location, variable) {
  const query = location.search.substring(1);
  const queryParams = query.split("&");
  const [code] = queryParams
    .map((queryParam) => {
      const params = queryParam.split("=");
      return params[0] === variable ? params[1] : null;
    })
    .filter((isCodeAvailable) => isCodeAvailable);

  return code;
}

export function getBaseUrl(url) {
  const urlObject = new URL(url);
  const baseUrl = urlObject.toString().replace(urlObject?.pathname, "/");
  return baseUrl;
}

export const convertObjectToQueryString = (obj) => {
  return (
    `?` +
    Object.keys(obj)
      .map((key) => {
        return `${key}=${encodeURIComponent(obj[key])}`;
      })
      .join("&")
  );
};

const REACT_APP_SSO_BASE_URL =
  "https://uat-auth.aiavatar.fun/connect/authorize";
const REACT_APP_SSO_REDIRECT_URL = "https://uat-wallet.aiavatar.fun/";
const REACT_APP_SSO_CLIENT_ID = "suzu_otc";
export const ssoLoginUrl = (props = {}) => {
  const { access_token, redirect_uri } = props;
  const urlParams = {
    response_type: "code",
    grant_type: "authorization_code",
    client_id: process.env.REACT_APP_SSO_CLIENT_ID || REACT_APP_SSO_CLIENT_ID,
    redirect_uri:
      redirect_uri ||
      process.env.REACT_APP_SSO_REDIRECT_URL ||
      REACT_APP_SSO_REDIRECT_URL,
    ...(access_token ? { access_token } : {}),
  };
  const queryString = convertObjectToQueryString(urlParams);
  return `${
    process.env.REACT_APP_SSO_BASE_URL || REACT_APP_SSO_BASE_URL
  }${queryString}`;
};

const REACT_APP_SSO_LOGOUT_BASE_URL =
  "https://uat-auth.aiavatar.fun/connect/endsession";
export const ssoLogoutUrl = (access_token) => {
  const urlParams = {
    access_token,
    post_logout_redirect_uri:
      process.env.REACT_APP_SSO_REDIRECT_URL || REACT_APP_SSO_REDIRECT_URL,
  };
  const queryString = convertObjectToQueryString(urlParams);
  return `${
    process.env.REACT_APP_SSO_LOGOUT_BASE_URL || REACT_APP_SSO_LOGOUT_BASE_URL
  }${queryString}`;
};

const RSA_KEY = "c3MwQDJPMjMkc1V6dXZlcg==";

export const encryptClientPassword = (content) => {
  const key = CryptoJS.enc.Base64.parse(RSA_KEY);
  const encryptedText = CryptoJS.AES.encrypt(content, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encryptedText.toString();
};

export const formatSearchUrl = (searchUrlString) => {
  let value = searchUrlString;
  let firstQuestionMarkIndex = value.indexOf("?"); // Tìm vị trí của kí tự '?' đầu tiên
  let secondQuestionMarkIndex = value.indexOf("?", firstQuestionMarkIndex + 1); // Tìm vị trí của kí tự '?' thứ hai

  if (secondQuestionMarkIndex !== -1) {
    // Nếu tìm thấy kí tự '?' thứ hai
    value =
      value.substring(0, secondQuestionMarkIndex) +
      "&" +
      value.substring(secondQuestionMarkIndex + 1);
  }
  return value;
};

export const setCookie = (key, value, option) => {
  let cookies = new Cookies();
  cookies.set(key, value, {
    domain: DOMAIN_COOKIE,
    maxAge: Date.now() + 36135 * 86400000,
    ...option,
  });
};

export const getCookie = (key, option) => {
  let cookies = new Cookies();
  return cookies.get(key, option);
};

export const removeCookie = (key, option) => {
  let cookies = new Cookies();
  cookies.remove(key, option);
};

export function buildGraph(data) {
  const graph = {};

  for (const entry of data) {
    if (!graph[entry.from_currency_code]) {
      graph[entry.from_currency_code] = [];
    }
    graph[entry.from_currency_code].push({
      currency: entry.to_currency_code,
      value: parseFloat(entry.bid_amount),
    });

    if (!graph[entry.to_currency_code]) {
      graph[entry.to_currency_code] = [];
    }
    graph[entry.to_currency_code].push({
      currency: entry.from_currency_code,
      value: 1 / parseFloat(entry.bid_amount),
    });
  }

  return graph;
}

export function getRate(data, from, to) {
  const item = data.find(
    (item) => item.from_currency_code === from && item.to_currency_code === to
  );
  if (item) {
    return parseFloat(item?.bid_amount || 1);
  }

  const itemReverse = data.find(
    (item) => item.from_currency_code === to && item.to_currency_code === from
  );
  if (itemReverse) {
    return 1 / parseFloat(itemReverse?.bid_amount || 1);
  }

  const graph = buildGraph(data);
  const queue = [{ currency: from, value: 1 }];
  const visited = new Set();

  while (queue.length > 0) {
    const { currency, value } = queue.shift();

    if (currency === to) {
      return value;
    }
    if (!graph[currency]) {
      return 1;
    }
    if (!visited.has(currency)) {
      visited.add(currency);
      for (const neighbor of graph[currency]) {
        queue.push({
          currency: neighbor.currency,
          value: value * neighbor.value,
        });
      }
    }
  }

  return 1;
}


const getRateThroughUSD = (data, from, to) => {
  return getRate(data, from, "USD") * getRate(data, "USD", to);
};

export function findConversionRateBFS(data, from, to) {
  const item = data.find(
    (item) => item.from_currency_code === from && item.to_currency_code === to
  );
  if (item) {
    return parseFloat(item?.bid_amount || 1);
  }

  const itemReverse = data.find(
    (item) => item.from_currency_code === to && item.to_currency_code === from
  );
  if (itemReverse) {
    return 1 / parseFloat(itemReverse?.bid_amount || 1);
  }
  return getRateThroughUSD(data, from, to);
}

export const isSOTd = (code) => {
  const codeLowerCase = code?.toString()?.toLowerCase();
  return (
    codeLowerCase === "sotx" ||
    codeLowerCase === "sot1" ||
    codeLowerCase === "sot2" ||
    codeLowerCase === "sot3" ||
    codeLowerCase === "sot4" ||
    codeLowerCase === "sot" ||
    codeLowerCase === "sotd" ||
    codeLowerCase === "sotdx" ||
    codeLowerCase === "sotd1" ||
    codeLowerCase === "sotd2" ||
    codeLowerCase === "sotd3" ||
    codeLowerCase === "sotd4" ||
    codeLowerCase === "sota" ||
    codeLowerCase.includes("sotd_") ||
    codeLowerCase.includes("sot_")
  );
};

export const isSOTdx = (code) => {
  const codeLowerCase = code?.toString()?.toLowerCase();
  if (!codeLowerCase) return false;
  return codeLowerCase?.includes("sotd_");
};

export const isSOTx = (code) => {
  const codeLowerCase = code?.toString()?.toLowerCase();
  if (!codeLowerCase) return false;
  return codeLowerCase?.includes("sot_");
};

export const isSOT = (code) => {
  const codeLowerCase = code?.toString()?.toLowerCase();
  return (
    codeLowerCase === "sotx" ||
    codeLowerCase === "sot1" ||
    codeLowerCase === "sot2" ||
    codeLowerCase === "sot3" ||
    codeLowerCase === "sot4"
  );
};

export const getCoinCodeImage = (code) => {
  if (isSOTx(code)) return "sot";
  if (isSOTdx(code)) return "sotd";
  return code;
};

const formatCurrency = (value, currencyCode) => {
  try {
    const prefix = MapCurrency[currencyCode] ?? USD;
    const decimalScale = decimalScaleByCurrency(
      baseCurrencyCode(true, currencyCode)
    )
    const thousandSeparator = thousandSeparatorByCurrency(currencyCode);
    const decimalSeparator = decimalSeparatorByCurrency(currencyCode);
    let [intPart, fracPart = ''] = Number(value)
      .toFixed(decimalScale)
      .split('.');

    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

    let formattedNumber = decimalScale > 0 ? intPart + decimalSeparator + fracPart : intPart;

    return `${prefix}${formattedNumber}`;
  } catch (e) {
    return "-";
  }
};
export const truncateAddress = (address, { nPrefix, nSuffix} = {}) => {
  if(!address) return '';
  const match = address.match(/^(0x[a-zA-Z0-9])[a-zA-Z0-9]+([a-zA-Z0-9])$/);
  const nTotalIsLongerThanAddress = (nPrefix ?? 0) + (nSuffix ?? 0) >= address.length -2 ;
  return match && !nTotalIsLongerThanAddress
    ? `0x${address.slice(2, 2 + (nPrefix ?? 2))}…${address.slice(address.length - (nSuffix ?? 4))}`
    : address;
}

export const truncateString = (address, nPrefix, nSuffix) => {
  if(!address) return '';
  const nTotalIsLongerThanAddress = (nPrefix ?? 0) + (nSuffix ?? 0) >= address.length -2 ;
  return !nTotalIsLongerThanAddress ? `${address.slice(0, (nPrefix ?? 2))}…${address.slice(address.length - (nSuffix ?? 4))}`: address
}

export const caculatorPeriod = (currentVal, prevVal, currency) => {
  const valChange = currentVal - prevVal;
  const period =
    prevVal !== 0 ? ((valChange / prevVal) * 100).toFixed(2) + "%" : "";
  const prefix = valChange > 0 ? "+" : "-";
  const periodString = period ? `${prefix}(${period})` : "";
  if (valChange) {
    return {
      value: `${prefix}${formatCurrency(valChange, currency)}${periodString}`,
      status: prefix,
    };
  }
  return {
    value: ``,
    status: prefix,
  };
};
export const dateFormat = (str, format = "YYYY-MM-DD HH:mm:ss") => {
  if (typeof str == "undefined") return;
  return moment(str).format(format);
};

export const dateFormatNumber = (str, format = "YYYY-MM-DD HH:mm:ss") => {
  if (typeof str == "undefined") return;
  return moment(Number(str)).format(format);
};

const THOUSAND = 1000;
const MILLION = 1000000;
const BILLION = 1000000000;
const TRILLION = 1000000000000;

export function formatNumberShort(number, startFromThousand = true) {
  let num = number;
  let suffix = "";
  if (num >= THOUSAND && num < MILLION && startFromThousand) {
    num = +(num / THOUSAND).toFixed(2);
    suffix = "K";
  } else if (num >= MILLION && num < BILLION) {
    num = +(num / MILLION).toFixed(2);
    suffix = "M";
  } else if (num >= BILLION && num < TRILLION) {
    num = +(num / BILLION).toFixed(2);
    suffix = "B";
  } else if (num >= TRILLION) {
    num = +(num / BILLION).toFixed(2);
    suffix = "T";
  }
  return {
    num,
    suffix,
  };
}
export function containsObject(obj, list) {
  var i;
  for (i = 0; i < list.length; i++) {
    if (list[i].id === obj.id) {
      return true;
    }
  }

  return false;
}

export const validatePassword = (password) => {
  let pattern = /^(?=.*[a-zA-Z])[a-zA-Z0-9]{6}$/;
  // let pattern = /(?=.*){6}/;
  return pattern.test(password);
};

export function RoundNumberOfDigit(number, digit) {
  return String(number).substring(
    String(number).indexOf("."),
    String(number).length - 1
  ).length > 8
    ? eToNumber(parseFloat(number)?.toFixed(digit))
    : eToNumber(parseFloat(number));
}
export function RoundNumberOfDigitSGT(number, digit) {
  return eToNumber(parseFloat(number)?.toFixed(digit));
}
export function eToNumber(num) {
  let sign = "";
  num += "";
  if (num.charAt(0) === "-") {
    num = num.substring(1);
    sign = "-";
  }
  let arr = num.split(/[e]/gi);
  if (arr.length < 2) return sign + num;
  let dot = (0.1).toLocaleString().substr(1, 1),
    n = arr[0],
    exp = +arr[1],
    w = (n = n.replace(/^0+/, "")).replace(dot, ""),
    pos = n.split(dot)[1] ? n.indexOf(dot) + exp : w.length + exp,
    L = pos - w.length,
    s = "" + BigInt(w);
  w =
    exp >= 0
      ? L >= 0
        ? s + "0".repeat(L)
        : r()
      : pos <= 0
      ? "0" + dot + "0".repeat(Math.abs(pos)) + s
      : r();
  L = w.split(dot);
  if ((L[0] == 0 && L[1] == 0) || (+w == 0 && +s == 0)) w = 0; //** added 9/10/2021
  return sign + w;
  function r() {
    return w.replace(new RegExp(`^(.{${pos}})(.)`), `$1${dot}$2`);
  }
}

export const calculateInterestAmount = (amount, interestRate) => {
  const amountNumber =
    typeof amount === "number" ? amount : Number(amount ?? 0);
  const rateNumber =
    typeof interestRate === "number"
      ? interestRate
      : Number(interestRate ?? 0);

  if (!Number.isFinite(amountNumber) || !Number.isFinite(rateNumber)) {
    return 0;
  }

  return Math.floor((amountNumber * rateNumber) / 100);
};

export const replaceString = (str, key, value) => {
  // if key is array => length key with length value must equal
  let resp = str;

  if (isArray(key)) {
    if (key?.length !== value?.length || !key.length) {
      return str;
    }
    for (let i = 0; i < key.length; i++) {
      resp = resp.split(key[i]).join(`${value[i]}`);
    }
  } else {
    resp = str.split(key).join(`${value}`);
  }
  return resp;
};

export const getBatchRunDate = () => {
  const commissionDate = process.env.REACT_APP_COMMISSION_DATE || 25;
  const currentDate = new Date().getDate();
  const endCurrentMonth = moment().endOf('month').format('DD');

  if (1 <= currentDate && currentDate < commissionDate) {
    return moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
  }
  if (commissionDate <= currentDate && currentDate <= endCurrentMonth) {
    return moment().startOf('month').format('YYYY-MM-DD');
  }
  return moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
}

export const sortByField = (array, field, direction = "asc") => {
  array.sort((a, b) => {
    let comparison = 0;

    if (direction === "asc") {
      if (a[field] > b[field]) {
        comparison = 1;
      } else if (a[field] < b[field]) {
        comparison = -1;
      }
    } else if (direction === "desc") {
      if (a[field] < b[field]) {
        comparison = 1;
      } else if (a[field] > b[field]) {
        comparison = -1;
      }
    }

    return comparison;
  });

  return array;
}

export const filterObjectsByObjectCondition = (array, conditionObject) => {
   return array.filter((item) => {
     for (let field in conditionObject) {
       if (
         conditionObject.hasOwnProperty(field) &&
         conditionObject[field]?.length > 0
       ) {
         let conditionValues = conditionObject[field];
         let itemValue = item[field];

         if (!conditionValues.includes(itemValue)) {
           return false;
         }
       }
     }
     return true;
   });
 };

 export const ENCRYPT_KEY_LENGTH = 32;
 export const ENCRYPT_SESSION_ID = 'dw8n8w5BkkQHMxwIC7NuX4q5ras9FRgdFVv7LEhw5dU=';
 
 function randomString(length) {
     const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
     const charactersLength = characters.length;
     let result = '';
     // Create an array of 32-bit unsigned integers
     const randomValues = new Uint32Array(length);
     // Generate random values
     window.crypto.getRandomValues(randomValues);
     randomValues.forEach((value) => {
         result += characters.charAt(value % charactersLength);
     });
     return result;
 }
 export const encryptMessageWeb = (text, sessionID) => {
     const key = sessionID.slice(sessionID.length - ENCRYPT_KEY_LENGTH, sessionID.length);
     const iv = randomString(16);
     const key_utf8 = CryptoJS.enc.Utf8.parse(key);
     const iv_utf8 = CryptoJS.enc.Utf8.parse(iv);
     var cipherData = CryptoJS.AES.encrypt(text, key_utf8, { iv: iv_utf8, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
     const ciphertext = CryptoJS.enc.Base64.stringify(cipherData.ciphertext);
     return ciphertext + CryptoJS.enc.Base64.stringify(iv_utf8) + key + "";
 }
 export const isAddress = function (address) {
  // function isAddress(address) {
  if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
    // check if it has the basic requirements of an address
    return false;
  } else if (
    /^(0x)?[0-9a-f]{40}$/.test(address) ||
    /^(0x)?[0-9A-F]{40}$/.test(address)
  ) {
    // If it's all small caps or all all caps, return "true
    return true;
  } else {
    // Otherwise check each case
    return isChecksumAddress(address);
  }
};

var isChecksumAddress = function (address) {
  const web3 = new Web3();

  return web3.utils.isAddress(address.toLowerCase(), true);;
};

export const formatPercentage = (value, decimalPlaces = 2) => {
  if (typeof value !== 'number' || isNaN(value)) {
    return `0.${'0'.repeat(decimalPlaces)}%`;
  }
  const decimals = Math.max(0, Math.floor(decimalPlaces));
  return `${(value * 100).toFixed(decimals)}%`;
};

export const formatNumber = (numb, fix = 0) => {
  if (!numb) numb = 0;
  let fixPow = Math.pow(10, fix);
  numb = Math.round(numb * fixPow) / fixPow;
  return numb.toString().replace(/\d(?=(\d{3})+(?!\d))/g, "$&,");
};

export const capitalizeText = (text) => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

export const decodeText = (text) => {
  try {
    const decoded = String(Buffer.from(text, "base64"));
    return decoded;
  } catch (error) {
    console.error("Error decoding text:", error);
    return text;
  }
};
export const encodeText = (text) => {
  try {
    const encoded = Buffer.from(text).toString("base64");
    return encoded;
  } catch (error) {
    console.error("Error encoding text:", error);
    return text;
  }
};
